import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';

const FooterStyled = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;

    display: -ms-grid;            
    -ms-grid-columns: 2fr 1fr;
    & *:nth-child(1) { -ms-grid-column: 1; }
    & *:nth-child(2) { -ms-grid-column: 2; }

    & *:nth-child(2) {
        text-align: right;
        color: ${Colours.primary};
    }
`;

const ColumnStyled = styled.span`
    font-size: 32px;
    font-weight: 700;
    line-height: 35px;
    letter-spacing: 0.2px;
    margin-block: 24px;
`;

interface InterfaceFooter {
    label: string,
    total: string,
}

export default ({ label, total }: InterfaceFooter) => (
    <FooterStyled>
        <ColumnStyled>{label}</ColumnStyled>
        <ColumnStyled>{total}</ColumnStyled>
    </FooterStyled>
)


// WEBPACK FOOTER //
// ./src/Components/TotalFooter.tsx